module.exports = {
  // JCRing成员页葡萄牙语言包
  JCRing_member: {
    index1: "Saúde dos membros",
    index2: "Grupos de saúde",
    index3: "Membros",
    index4: "Adicionar grupo",
    index5: "Grupos unidos",
    index6: "Configurações de alerta",
    index7:
      "Deixe aqueles que se preocupam com sua saúde se importarem mais com você à distância, com cuidado oportuno",
    index8: "Ainda não entrou em nenhum grupo",
    index9: "Centro de mensagens",
    index10:
      "Convidar para se juntar através de / telefone / e-mail / código QR / WeChat",

    addgroup1: "Nome do grupo",
    addgroup2: "Tipo de grupo",
    addgroup3: "Por favor, insira o nome do grupo",
    addgroup4: "Grupo familiar",
    addgroup5: "Grupo de empresa",
    addgroup6: "Outro grupo",
    addgroup7: "Grupo médico",
    addgroup8: "Grupo escolar",
    addgroup9: "Confirmar",
    addgroup10: "Cancelar",
    addgroup11: "Criar agora",
    addgroup12: "O nome do grupo já existe",

    memberlist1: "Lista de membros",
    memberlist2: "Tem",
    memberlist3: "Exceções",
    memberlist4: "Normal",
    memberlist5: "Adicionar membro",
    memberlist6: "Dissolver",
    memberlist7: "Sem membros",
    memberlist8: "Carregando...",
    memberlist9: "Dissolver este grupo?",
    memberlist10: "Dissolvido com sucesso",
    memberlist11: "Salvo com sucesso",
    memberlist12: "Editar informações do grupo",
    memberlist13: "Dissolver grupo",
    memberlist14: "Visão geral da saúde",
    memberlist15: "Itens normais",
    memberlist16: "Itens anormais",
    memberlist17: "Clique para ver",
    memberlist18: "Sem dados de ontem",
    memberlist19: "Ontem",
    memberlist20: "Enviado",
    memberlist21: "Convites para o grupo enviados, aguardando confirmação",

    updatemember1: "Foto de perfil",
    updatemember2: "Mudar",
    updatemember3: "Apelido original",
    updatemember4: "Editar apelido",

    healthdata1: "dados de saúde",
    healthdata2: "dados de saúde",
    healthdata3: "Domingo",
    healthdata4: "Segunda-feira",
    healthdata5: "Terça-feira",
    healthdata6: "Quarta-feira",
    healthdata7: "Quinta-feira",
    healthdata8: "Sexta-feira",
    healthdata9: "Sábado",
    healthdata10: "Frequência cardíaca",
    healthdata11: "Variabilidade da frequência cardíaca",
    healthdata12: "Pressão arterial sistólica",
    healthdata13: "Pressão arterial diastólica",
    healthdata14: "Variabilidade da temperatura",
    healthdata15: "Saturação de oxigênio no sangue",
    healthdata16: "Sono",
    healthdata17: "Estresse",
    healthdata18: "Colesterol",
    healthdata19: "Triglicerídeos",
    healthdata20: "Colesterol LDL",
    healthdata21: "Colesterol HDL",
    healthdata22: "Glicose no sangue",
    healthdata23: "Antes das refeições",
    healthdata24: "Após as refeições",
    healthdata25: "Consumo máximo de oxigênio",
    healthdata26: "Respiração",
    healthdata27: "Passos",
    healthdata28: "Passo",
    healthdata29: "Calorias",
    healthdata30: "kcal",
    healthdata31: "Distância",
    healthdata32: "Quilómetros",
    healthdata33: "Ritmo",
    healthdata35: "Segundos/km",
    healthdata36: "Minutos",
    healthdata37: "Carregando dados de saúde",
    healthdata38: "Dados de exercício",
    healthdata39: "Alertas",
    healthdata40: "Não autorizado",
    healthdata41: "Editar informações do membro",
    healthdata42: "Excluir membro",
    healthdata43: "E-mail:",
    healthdata44: "Telefone:",
    healthdata45: "Excluir este membro?",
    healthdata46: "Datas futuras não podem ser exibidas",
    healthdata47: "Hoje",

    addmember1: "Convidar membros",
    addmember2: "Adicionar conta de membro",
    addmember4:
      "Usando 'Contas de membros', você pode visualizar os dados de saúde dos membros e definir faixas de dados de alerta para um melhor monitoramento da saúde deles",
    addmember5: "Saiba mais",
    addmember6: "Membros do grupo de saúde",
    addmember7: "Convidar",
    addmember8: "Entrar",
    addmember9: "Convidar escaneando o código QR",
    addmember10: "Convite pelo WeChat",
    addmember11: "Convidar para entrar no grupo escaneando o código QR",
    addmember12: "Convidar para entrar no grupo pelo WeChat",
    addmember13: "Convite por telefone/e-mail",
    addmember14: "Convidar para entrar no grupo por telefone/e-mail",
    addmember15:
      "Convide os membros a entrar para visualizar o estado de saúde deles",
    addmember16: "Enviar convite",
    addmember17: "Enviado",
    addmember18: "Aguardando confirmação",
    addmember19: "Já entrei",
    addmember20: "Compartilhar agora",
    addmember21: "Salvar imagem",
    addmember22: "Recusei",
    addmember23: "Saí",
    addmember24: "O membro saiu",
    addmember25: "O membro recusou",
    addmember26: "O membro entrou",
    addmember27: "Outras formas de adicionar",

    code1: "Código QR do grupo",
    code2: "Grupo de gestão de saúde",
    code3:
      "Este código QR é válido por 5 minutos. Por favor, use-o prontamente.",

    invide1: "Convite para o grupo",
    invide2: "Saúde dos membros",
    invide3: "Convidando você para entrar no grupo...",
    invide4: "Entrar no grupo",
    invide5:
      "Para a segurança dos seus dados, é recomendável verificar as informações do grupo antes de ingressar.",
    invide6:
      "Após entrar no grupo, você autorizará os seguidores a visualizar seus dados de saúde.",

    sethealthdata1: "Configurações de dados de saúde",
    sethealthdata2: "Confirmar",
    sethealthdata3: "Por favor, defina um apelido",
    sethealthdata4: "Permitir tudo",
    sethealthdata5: "Definir apelido",
    sethealthdata6: "Salvar",
    sethealthdata7: "Por favor, insira",
    sethealthdata8: "Por favor, faça o upload no formato de imagem",
    sethealthdata9: "Por favor, defina tanto o apelido quanto o avatar",
    sethealthdata10: "Por favor, defina um avatar",
    sethealthdata11: "O comprimento do apelido deve ser de 1 a 8 caracteres",

    setscope1: "Faixa de frequência cardíaca",
    setscope2: "Faixa de temperatura",
    setscope3: "Faixa de sono",
    setscope4: "Faixa de frequência cardíaca fetal",
    setscope5: "Glicose no sangue antes das refeições",
    setscope6: "Glicose no sangue após as refeições",
    setscope7: "Faixa de oxigênio no sangue",
    setscope8: "Ácido úrico masculino",
    setscope9: "Ácido úrico feminino",
    setscope10: "Pressão arterial sistólica",
    setscope11: "Pressão arterial diastólica",
    setscope12: "Limite superior",
    setscope13: "Limite inferior",
    setscope14: "Configurações de alerta",
    setscope15: "Configurações salvas",
    setscope16: "Limite superior",
    setscope17: "Limite inferior",
    setscope18: "Alerta",

    onload1: "Clique",
    onload2: "Entrar no grupo de saúde",
    onload3: "Por favor, abra no navegador",
    onload4: "Entendido",
    onload5: "Youhong Saúde, Saúde inteligente todos os dias",
    onload6: "Baixar gratuitamente na App Store",
    onload7: "Baixar grátis",
    onload8: "Link expirado",
    onload9: "Código QR expirado",
    onload10: "Entrada com sucesso",

    // invide1: "Convite para o grupo",
    // invide2: "Saúde dos membros",
    // invide3: "Convidando você para entrar no grupo...",
    // invide4: "Entrar no grupo",
    // invide5:
    //   "Para a segurança dos seus dados, é recomendável verificar as informações do grupo antes de ingressar.",
    // invide6:
    //   "Após entrar no grupo, você autorizará os seguidores a visualizar seus dados de saúde.",

    guide1:
      "Após acessar a saúde dos membros, você precisa criar primeiro o tipo de grupo apropriado.",
    guide2:
      "Após criar o grupo, entre no grupo para ver o resumo de saúde dos usuários e convidar novos membros.",
    guide3:
      "Para convidar novos membros para o grupo, você pode usar métodos como escanear um código QR, WeChat, número de telefone/e-mail. Após os novos membros entrarem no grupo, você pode ver suas atualizações diárias de saúde.",
    guide4:
      "Clique para ver o resumo de saúde, onde você pode ver os dados de saúde dos membros e determinar condições normais ou anormais.",
    guide5: "Próximo",
    guide6: "Concluir",
    guide7: "Excede o valor de alerta",

    invite1: "Convidar por número de telefone/email",
    invite2: "Por favor insira a conta",
    invite3: "Por favor insira o número de telefone",
    invite4: "Por favor insira o e-mail",
    invite5: "Por favor insira um número de telefone válido",
    invite6: "Por favor insira um e-mail válido",
    invite7: "Já entrou neste grupo",
    invite8: "O usuário não existe",
    invite9: "Selecione país ou região",
    invite10: "Por favor insira palavras-chave de pesquisa",
    invite11: "Confirmar usuário",
    invite12: "Convidar",
    invite13: "Por favor selecione"
  }
};



// WEBPACK FOOTER //
// ./src/lang/pt.js